(function(){
  var DV=window.DV; if(!DV) return;
  var $=function(id){return document.getElementById(id)};
  var F=DV.F;

  /* ---- flavor cards: tasting notes, meters, finder ---- */
  var NOTES={
    rasp:{t:'Bright berry with a little tart snap.',tart:4,sweet:3,m:['tart','sweet']},
    melon:{t:'Juicy, light and summery. Easy to love.',tart:2,sweet:4,m:['sweet','fresh']},
    apple:{t:'Crisp green apple with a sour-candy kick.',tart:5,sweet:2,m:['tart','fresh']},
    orange:{t:'Zesty, sunny citrus. Tastes like a treat.',tart:3,sweet:4,m:['candy','fresh']},
    berry:{t:'Deep, jammy berry. The most candy-like of the five.',tart:2,sweet:5,m:['candy','sweet']}
  };
  var LBL={tart:'tart',sweet:'sweet and juicy',candy:'candy-shop',fresh:'fresh and crisp'};
  var row=$('flRow'), keys=Object.keys(F), cards=row?[].slice.call(row.querySelectorAll('.fl-card')):[];
  cards.forEach(function(c,i){
    var k=keys[i], f=F[k], n=NOTES[k]||{t:'',tart:3,sweet:3,m:[]};
    c.dataset.k=k;
    c.setAttribute('aria-label','Choose '+f.n+'. '+n.t);
    c.innerHTML='<span class="a2-fc-top"><b>'+f.n+'</b><span class="a2-fc-tag">Your pick</span></span>'+
      '<span class="a2-fc-note">'+n.t+'</span>'+
      '<span class="a2-meters" aria-hidden="true"><span>Tart<i style="--v:'+n.tart+'"></i></span><span>Sweet<i style="--v:'+n.sweet+'"></i></span></span>'+
      '<img src="//shop.dovive.com/cdn/shop/t/1/assets/'+k+'_pack.webp" alt="" loading="lazy">'+
      '<span class="a2-fc-cta">Choose '+f.n+'<svg class="ic"><use href="#i-check"/></svg></span>';
  });
  var out=$('a2MatchOut'), mbtns=[].slice.call(document.querySelectorAll('.a2-match button'));
  mbtns.forEach(function(b){b.addEventListener('click',function(){
    var m=b.dataset.m;
    mbtns.forEach(function(x){x.setAttribute('aria-pressed',x===b)});
    if(m==='all'){row.classList.remove('filtering');cards.forEach(function(c){c.classList.remove('hit')});
      out.innerHTML='Tap a card to pick that flavor. You can mix two flavors in a 2-jar order.';return}
    var hits=[];
    cards.forEach(function(c){var h=(NOTES[c.dataset.k]||{m:[]}).m.indexOf(m)>-1;c.classList.toggle('hit',h);if(h)hits.push(F[c.dataset.k].n)});
    row.classList.add('filtering');
    out.innerHTML='If you like it '+LBL[m]+', try <b>'+hits.join('</b> or <b>')+'</b>. Tap a card to pick it.';
    var first=row.querySelector('.fl-card.hit');
    if(first&&row.scrollWidth>row.clientWidth+4){row.scrollTo({left:first.offsetLeft-20,behavior:'smooth'})}
  })});

  /* ---- lab card: follow the flavor tabs from the main script ---- */
  var ct=$('coaTabs');
  function showCoa(k){
    if(!F[k])return;
    var nm=$('a2CoaName'),dot=$('a2CoaDot'),img=$('a2CoaImg');
    if(nm)nm.textContent=F[k].n;
    if(dot)dot.style.background=F[k].c;
    if(img){img.src='//shop.dovive.com/cdn/shop/t/1/assets/'+k+'_pack.webp';img.alt=''}
    var msg=$('a2LotMsg');if(msg)msg.textContent='';
  }
  if(ct){
    ct.addEventListener('click',function(e){var b=e.target.closest('button[data-k]');if(b)showCoa(b.dataset.k)});
  }
  function syncCoa(k){if(!ct)return;var b=ct.querySelector('button[data-k="'+k+'"]');if(b&&b.getAttribute('aria-pressed')!=='true')b.click();else showCoa(k)}

  /* ---- lot lookup ---- */
  var lot=$('a2Lot');
  if(lot)lot.addEventListener('submit',function(e){
    e.preventDefault();
    var v=($('a2LotIn').value||'').trim().replace(/[<>&"]/g,''), msg=$('a2LotMsg');
    if(!v){msg.textContent='Type the lot number from the bottom of your jar first.';$('a2LotIn').focus();return}
    msg.innerHTML='The published Eurofins report covers lot C202602 (one composite sample of all 5 flavors). Reports for new lots will be added when available.';
  });

  /* ---- keep everything in step with the buy box ---- */
  var last=null;
  function onRender(st){
    cards.forEach(function(c){c.classList.toggle('on',c.dataset.k===st.fl)});
    if(st.fl!==last){last=st.fl;syncCoa(st.fl)}
  }
  DV.hooks.push(onRender);
  onRender(DV.st);
})();

